import { action, observable } from 'mobx'
import { message } from 'hljd'
import Api from '@api/hotel/albumManage'
import { APPROVAL_STATUS } from '@components/Hotel/constant'

export const ALBUM = {
  PHOTO: 1,
  VIDEO: 2
}

const SCENE = {
  photo: '图片',
  video: '视频',
  vr: '全景'
}

export default class {
  // 预览的封面
  @observable previewCover = null
  // 预览的模式
  @observable previewScene = 'photo'
  // 审核通知的文本
  @observable approvalText = null
  // 正在保存的loading
  @observable isSaving = false

  @observable photo = {}
  @observable video = {}
  @observable vr = {}

  // 初始化封面信息
  @action
  getCoverInfo = async () => {
    const { data } = await Api.getHotelCover()

    if (!data) {
      return
    }

    const { reason, status, cover_info } = data
    const { photo, video } = cover_info
    this.photo = photo || {}
    this.video = video || {}
    /*   this.vr = vr || []
    if (vr && vr.cover_path) {
      this.previewScene = 'vr'
    } else if (video && video.cover_path) {
      this.previewScene = 'video'
    } else {
    }*/
    this.previewScene = 'photo'

    if (status != APPROVAL_STATUS.PASS) {
      this.approvalText =
        data.status == APPROVAL_STATUS.WAIT
          ? '审核中！审核结束后，您将收到我们的通知。'
          : `审核未通过，${reason}`
    }
    this.updateCoverPreview()
  }

  // 修改封面信息
  @action
  changeCover = (scene, info) => {
    this[scene] = info
    this.updateCoverPreview()
  }

  // 保存封面信息
  @action
  saveCover = async () => {
    const { photo, video, vr } = this
    if (!photo) {
      message.warning('请设置图片封面')
      return
    }

    this.isSaving = true
    const params = { photo, video, vr }
    const { success } = await Api.saveHotelCover(params)
    if (success) {
      await this.getCoverInfo()
      message.success('保存成功，已提交审核')
    }
    this.isSaving = false
  }

  // 修改预览方式
  @action
  changeScene = value => {
    this.previewScene = value
    this.updateCoverPreview()
  }

  // 获取预览信息
  @action
  updateCoverPreview = () => {
    // 跳转页面上方兼容safari,chrome
    // MainStore.scrollTopMain()
    // document.documentElement.scrollTop = 0
    // document.body.scrollTop = 0
    this.previewCover = JSON.parse(JSON.stringify(this[this.previewScene]))
    if (!this.previewCover.cover_path) {
      message.warning(`请设置${SCENE[this.previewScene]}封面`)
    }
  }

  // 验证封面信息
  checkCoverInfo = () => {
    const { photo, video, vr } = this
    if (photo.cover_path || video.cover_path || vr.cover_path) {
      return true
    }
    return false
  }
}
